(() => {
  const roots = document.querySelectorAll('[data-pfl-root]');

  const formatNumber = (value) =>
    new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 0 }).format(value);

  const parseOrderValue = (value) => {
    const digits = String(value || '').replace(/[^\d]/g, '').slice(0, 6);
    return {
      display: digits,
      number: Math.min(100000, Math.max(0, Number(digits || 0)))
    };
  };

  roots.forEach((root) => {
    if (root.dataset.pflInitialized === 'true') return;
    root.dataset.pflInitialized = 'true';

    const input = root.querySelector('[data-pfl-order-value]');
    const result = root.querySelector('[data-pfl-points-result]');
    const message = root.querySelector('[data-pfl-reward-message]');
    const progress = root.querySelector('[data-pfl-progress]');
    const rate = Math.max(0, Number(root.dataset.pointsRate || 0));

    const rewards = [...root.querySelectorAll('[data-pfl-reward]')]
      .map((card) => ({
        cost: Math.max(0, Number(card.dataset.rewardCost || 0)),
        name: card.dataset.rewardName || 'nagroda'
      }))
      .filter((reward) => reward.cost > 0)
      .sort((a, b) => a.cost - b.cost);

    if (!input || !result) return;

    const update = () => {
      const parsed = parseOrderValue(input.value);

      if (input.value !== parsed.display) {
        input.value = parsed.display;
      }

      const points = Math.floor(parsed.number * rate);
      result.textContent = formatNumber(points);

      if (!rewards.length) {
        if (progress) progress.style.width = '0%';
        if (message) message.textContent = 'Sprawdź dostępne nagrody w panelu programu.';
        return;
      }

      const nextReward = rewards.find((reward) => reward.cost > points);
      const achieved = [...rewards].reverse().find((reward) => reward.cost <= points);

      if (nextReward) {
        const missing = nextReward.cost - points;
        const percentage = Math.min(100, Math.max(0, (points / nextReward.cost) * 100));

        if (progress) progress.style.width = `${percentage}%`;

        if (message) {
          message.textContent = achieved
            ? `Masz próg nagrody „${achieved.name}”. Do kolejnej brakuje ${formatNumber(missing)} pkt.`
            : `Do nagrody „${nextReward.name}” brakuje Ci ${formatNumber(missing)} pkt.`;
        }
      } else {
        if (progress) progress.style.width = '100%';
        if (message) {
          message.textContent = `Osiągasz próg najwyższej pokazanej nagrody: „${rewards[rewards.length - 1].name}”.`;
        }
      }
    };

    input.addEventListener('input', update);

    // Dodatkowe zabezpieczenie: przewijanie strony nigdy nie zmienia wpisanej kwoty.
    input.addEventListener('wheel', () => {
      if (document.activeElement === input) input.blur();
    }, { passive: true });

    input.addEventListener('paste', () => {
      window.requestAnimationFrame(update);
    });

    update();
  });
})();
